import { Size } from '../constants';

/**
 * Constants for the TabNavigator component
 */
export enum TabNavigatorType {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}

export type TabNavigatorSize = Extract<Size, Size.SMALL | Size.LARGE>;
